<pg-home>

  <section class="hero">
    <video src={ video } autoplay loop muted="muted"></video>
    <div class="layer">
      <div class="slogan">
        <h1>UNIFORMES CORPORATIVOS</h1>
        <span class="separator"></span>
        <span class="sentence">Oferecemos as melhores soluções em uniformização</span>
      </div>
      <div class="whatsapp">
        <span>Orçamentos:</span>
        <a target="_blank" href={ walink }>
          <whatsapp-square-brands />
          <p>Clique <b>aqui</b></p>
        </a>
      </div>
    </div>
  </section>

  <section class="about">
    <span class="section-anchor-position" id="sobre"></span>
    <div class="section-content">
      <img src={ aboutImg } alt="">
      <div class="text">
        <h2>SOBRE A JGA CONFECÇÕES</h2>
        <p>A JGA é uma empresa especializada em confecção de alta qualidade com experiencia de mais de 10 anos no mercado de moda.</p>
        <p>Confeccionamos uniformes profissionais para os mais diversos segmentos de empresas. Nossos uniformes são confeccionados em tecidos selecionados e prezamos pela qualidade em cada etapa do processo, desde a modelagem até o acabamento.</p>
        <p>Nossa missão é identificar a real necessidade da sua empresa e propor alternativas criativas e adequadas para cada finalidade. Nosso principal objetivo é nos tornar parceiros dos nossos clientes, oferecendo um produto de qualidade, com preço justo dentro do prazo acordado.</p>
      </div>
    </div>
  </section>

  <!-- <section class="products">
    <span class="section-anchor-position" id="produtos"></span>
    <div class="section-content">
      <div class="items">
        <div class="item" each={ item in products }>
          <h3>{ item.title }</h3>
          <img src="media/{ item.img }" alt={ item.title }>
        </div>
      </div>
    </div>
  </section> -->

  <!-- <section class="customers">
    <span class="section-anchor-position" id="clientes"></span>
    <div class="section-content">
      <h2>NOSSOS CLIENTES:</h2>
      <span class="separator"></span>
      <div class="items">
        <div class="customer-container" each={ item in customers }><img src="media/{ item.img }" alt={ item.title }></div>
      </div>
    </div>
  </section> -->

  <section class="contact">
    <span class="section-anchor-position" id="contato"></span>
    <div class="section-content">
      <a href="mailto: contato@jgaconfeccoes.com.br">contato@jgaconfeccoes.com.br</a>
      <div class="whatsapp">
        <a target="_blank" href={ walink }>
          <whatsapp-square-brands />
          <p>61 9.9985-6142</p>
        </a>
      </div>
    </div>
  </section>

  <script>
    import './pg-home.scss'
    import video from '../media/background-video.mp4'
    import aboutImg from '../media/about-img.jpg'
    import logo from '../media/logo.png'
    import { customers, products } from './data.js'
    import { handleWaLink } from './utils.js'

    import WhatsappSquareBrands from './svgs/whatsapp-square-brands.riot'


    export default {
      logo, video, aboutImg, customers, products, handleWaLink,
      components: {
        WhatsappSquareBrands
      },
      onBeforeMount(props, state) {
        this.walink = handleWaLink('Olá, tudo bem? Gostaria de fazer um orçamento, por favor!', '5561999856142')
      },
      onMounted(props, state) {
        this.$('video').play()
      }
    }

  </script>
</pg-home>
